<template lang="pug">
    .timeline-container
        .timeline-step(v-if="inProgress || completed || error")
            .timeline-indicator
                .timeline-icon(:style="{ borderColor: iconBorderColor }")
                    v-icon(v-if="completed || error" :color="iconColor(completed)") {{ iconType(completed) }}
                    v-progress-circular(
                        v-else-if="inProgress"
                        indeterminate
                        width="2"
                        color="primary"
                    )
                .timeline-connector
            
            .timeline-header
                span.text-ih7.volie-color-blue.ma-2 {{ title }}
                .timeline-status(v-if="inProgress")
                    span.loading-text {{ loadingText }}
                .timeline-status(v-if="error")
                    span(style="color: var(--error)") {{ errorMessage }}
            
            .timeline-body(v-if="completed || error") 
                slot(name="timeline-body")
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    data() {
        return {

        }
    },
    methods: {
        iconColor(isCompleted: boolean) {
            return isCompleted ? 'var(--success)' : 'var(--error)';
        },
        iconType(isCompleted: boolean) {
            return isCompleted ? 'mdi-check' : 'mdi-close';
        },
    },
    computed: {
        iconBorderColor() {
            if (this.completed) {
                return 'var(--success)';
            } else if (this.error) {
                return 'var(--error)';
            } else {
                return 'transparent';
            }
        },
    },
    components: {

    },
    props: {
        completed: Boolean,
        error: Boolean,
        errorMessage: String,
        inProgress: Boolean,
        loadingText: String,
        title: String,
    },
})
</script>

<style lang="scss" scoped>
    .timeline-container {
        padding-left: 60px;

        .timeline-step {
            position: relative;
            margin-bottom: 40px;

            .timeline-indicator {
                height: 100%;
                position: absolute;
                left: -60px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .timeline-icon {
                    border-radius: 50%;
                    padding: 5px;
                    border: 1px solid;
                    z-index: 2;
                    position: relative;
                }

                .timeline-connector {
                    width: 2px;
                    height: 100%;
                    background: var(--off-white);
                    margin-top: 10px;
                }
            }

            .timeline-header {
                margin-bottom: 10px;

                .timeline-status {
                    font-size: 14px;
                    color: var(--volie-gray);
                    margin-top: 5px;
                }
            }
        }
    }
</style>